import { WIDGET_LOAD_TIME_INFO_NAME } from '../const'

const sendInfoLog = (widgetHelpers, logger, appName) => {
  const { widgetLoadTime, initWidgetOptions } = widgetHelpers
  const { product } = initWidgetOptions || {}
  if (logger) {
    logger.info(WIDGET_LOAD_TIME_INFO_NAME, {
      widgetLoadTime,
      product,
      initWidgetOptions,
      appName
    })
  }
}

export default sendInfoLog
